import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'

import Highlight from '@/components/Highlight'

type Props = {
  searchFilter: string
  firstName: string
  lastName: string
  email: string
  phoneNumber: string | null
  userGroup?: {
    description: string
  }
  onEdit: () => void
}

export const UserListItem: FC<Props> = ({
  firstName,
  lastName,
  email,
  phoneNumber,
  searchFilter,
  onEdit,
  userGroup,
}) => (
  <tr onClick={onEdit}>
    <Td>
      <Highlight pattern={searchFilter} text={`${firstName} ${lastName}`} />
    </Td>
    <Td>
      <Highlight pattern={searchFilter} text={userGroup?.description} />
    </Td>
    <Td className="hidden md:table-cell">
      <Highlight pattern={searchFilter} text={email} />
    </Td>
    <Td className="hidden md:table-cell">
      <Highlight pattern={searchFilter} text={phoneNumber || ''} />
    </Td>
  </tr>
)
